module.exports = __webpack_public_path__ + "static/darkThree-064b75533ba3fc0fd7a55adbd6e5f820.png";